import { render, staticRenderFns } from "./extras-overview-email.vue?vue&type=template&id=5e6d01ca&"
import script from "./extras-overview-email.vue?vue&type=script&lang=js&"
export * from "./extras-overview-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports